import * as Track from '@project/shared/utils/tracking/js/tracking';
import * as Cookies from 'js-cookie';
import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { SapCdcFormGlobal } from '../../sapcdc-form-global/js/sapcdc-form-global';

const classes = {
	buttonClose: 'js-m-sapcdc-lightbox__close',
	stateLightboxVisible: 'state-m-sapcdc-lightbox--visible',
	lightboxDialog: 'm-sapcdc-lightbox__dialog',
	lightboxLoading: 'm-sapcdc-lightbox__dialog-loading',
	lightbox: 'm-sapcdc-lightbox',
	stateContentHide: 'm-sapcdc-lightbox--block-hidden',
	blockedMsg: 'js-m-sapcdc-lightbox-blocked-msg',
	formProductName: 'js-m-stage-product__headline',
};

let preferencesCampaignId: string = '';
let originalLinkHref: string = '';
let originalvideoId: string = '';
let originalHrefTarget: string = '';

@createModule('SapCdcLightbox')
export class SapCdcLightbox extends TerrificSpec {
	$ctx: JQuery;
	sapCdcService: SapCdcFormGlobal;
	productNameValue: string;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.sapCdcService = new SapCdcFormGlobal();

		let $this = this;
		setTimeout(function() {
			var cdcflowId = $this.$ctx.data('t-cdcflowid');
			var pageHref = $this.$ctx.data('t-pagehref');
			var closeButtonDisabled = $this.$ctx.data('t-closebuttondisabled');
			var campaignId = $this.$ctx.data('t-cdccampaign-main-id');
			var themeModeAttribute = $this.$ctx.data('t-thememodeattribute');
			var target = $this.$ctx.data('t-target');
			if (cdcflowId != '' && cdcflowId != undefined && cdcflowId.length > 0) {
				$this.getCdcLightboxView(
					cdcflowId,
					pageHref,
					closeButtonDisabled,
					themeModeAttribute,
					campaignId,
					target
				);
			}
		}, 1000);

		setTimeout(function() {
			$('html')
				.find('a')
				.on('click', function(ev: Event) {
					var flowId = $(this).data('cdcflow-id');
					var closeButtonDisabled = $(this).data('cdcflow-close-disabled');
					var videoId = $(this).data('video-id');
					var campaignId = $(this).data('cdccampaign-main-id');
					let href = $(this).attr('href');
					var themeModeAttribute = $(this).data('cdc-themeattribute');
					var target = $(this).attr('target');
					if (flowId != undefined) {
						if (flowId.length > 0) {
							if (!Track.isKnownCdcLead()) {
								ev.preventDefault();
								$this.getCdcLightboxView(
									flowId,
									href,
									closeButtonDisabled,
									themeModeAttribute,
									campaignId,
									videoId,
									target
								);
								return false;
							} else {
								ev.preventDefault();
								$this.getCdcLightboxData(
									flowId,
									href,
									closeButtonDisabled,
									themeModeAttribute,
									campaignId,
									videoId,
									target
								);
							}
						} else {
							console.log('lightbox: flow-id is empty');
						}
					} else {
						console.log('lightbox: flow-id is undefined');
					}
				});
		}, 1000);

		resolve();
	}

	getCdcLightboxView(
		flowId: string,
		originalHref: string,
		closeButtonDisabled: boolean,
		themeModeAttribute: string = '',
		campaignId: string = '',
		videoId: string = '',
		target: string = ''
	) {
		// partial view is called, show black-transparent overlay and loading indicator
		this.showLightbox();
		this.showIndicator();

		if (closeButtonDisabled == undefined) {
			closeButtonDisabled = false;
		}

		if (originalHref == undefined) {
			originalHref = '';
		}
		if (themeModeAttribute === undefined || themeModeAttribute === null || themeModeAttribute === '') {
			themeModeAttribute = $('html').hasClass('l-campaign') ? 'l-campaign' : themeModeAttribute;
		}

		var formProductName = $('html').find(`.${classes.formProductName}`);
		if (formProductName.length > 0) {
			this.productNameValue = $(formProductName[0]).text();
		}

		preferencesCampaignId = campaignId;

		const endpoint = '/partial-updates/sapcdc/lightboxpartial';
		$.ajax({
			type: 'get',
			url: endpoint,
			dataType: 'html',
			data: {
				flowId: flowId,
				originLink: originalHref,
				closeButtonDisabled: closeButtonDisabled,
				themeModeAttribute: themeModeAttribute,
				campaignId: campaignId,
				productName: this.productNameValue,
			},
			success: (response: any) => {
				if (response.length > 2) {
					let $dialog = this.$ctx.find(`div.${classes.lightboxDialog}`);
					$dialog.empty();
					$dialog.append(response);
					this.rebindEvents();
					this.loadForm(originalHref, videoId, target);
				} else {
					console.log('lightbox: get partial-view failed');
					this.closeLightbox();
					this.doSubmitAction(false, originalHref, videoId);
				}
			},
			complete: () => {},
			error: (xhr: any, status: string, error: string) => {
				console.log(
					`lightbox: get partial-view error, endpoint: ${endpoint}, ${xhr.status}, ${
						xhr.statusText
					}, ${error}`
				);
				this.doSubmitAction(false, originalHref, videoId);
			},
		});
	}
	removeAllListeners() {
		if ($('.m-teaser-large__caption-button').length) {
			const original: any = document.querySelector('.m-teaser-large__caption-button');
			const clone = original.cloneNode(true);
			original.parentNode.replaceChild(clone, original);
		}
	}
	getCdcLightboxData(
		flowId: string,
		originalHref: string,
		closeButtonDisabled: boolean,
		themeModeAttribute: string = '',
		campaignId: string = '',
		videoId: string = '',
		target: string = ''
	) {
		let _this = this;
		let clickEventTriggered = false;
		if (closeButtonDisabled == undefined) {
			closeButtonDisabled = false;
		}

		if (originalHref == undefined) {
			originalHref = '';
		}
		if (themeModeAttribute === undefined || themeModeAttribute === null || themeModeAttribute === '') {
			themeModeAttribute = $('html').hasClass('l-campaign') ? 'l-campaign' : themeModeAttribute;
		}
		this.showLightbox();
		this.showIndicator();

		$.ajax({
			type: 'get',
			url:
				window.location.origin +
				'/partial-updates/sapcdc/lightboxpartialformdata?' +
				'flowId=' +
				flowId +
				'&originLink=' +
				originalHref +
				'&isDisplayForm=true' +
				'&campaignId=' +
				campaignId,
			dataType: 'html',
			success: (response: any) => {
				if (response.length > 2) {
					this.closeLightbox();
					let $dialog = _this.$ctx.find(`div.${classes.lightboxDialog}`);
					$dialog.empty();
					$dialog.append(response);
					_this.rebindEvents();
					let $lightboxContainer = _this.$ctx.find(`div[data-id="SapCdcLightboxContainer"]`);
					_this.sapCdcService.setCampaignId($lightboxContainer);
					var IsHiddenFormSubmitrequired = $lightboxContainer.data('hidden-form-submit-required');
					var HiddenFormSubmitId = $lightboxContainer.data('lightbox-form-id');
					let $mainFormContainer = $lightboxContainer.find(`div[data-id="formContainerForSapCdc"]`);
					let sendDataToPreferences = $($mainFormContainer).attr('data-cdp-send-preferences-data');
					let submissionType = $($mainFormContainer).attr('data-form-submission-type');
					let submissionSource = $($mainFormContainer).attr('data-form-submission-source');

					if (IsHiddenFormSubmitrequired == true) {
						let cdcProfileData = Cookies.getJSON('cdcProfileData');
						if (cdcProfileData) {
							const selectedPreference =
								sendDataToPreferences !== undefined && sendDataToPreferences === 'true'
									? encodeURIComponent((window as any).dataLayer[0].preferenceTag)
									: '';
							this.SubmitWebContentDownloadPreferences(
								submissionType,
								submissionSource,
								selectedPreference,
								cdcProfileData,
								campaignId
							);
							if (HiddenFormSubmitId !== undefined && clickEventTriggered !== true) {
								if (originalHref != undefined && originalHref.length > 0) {
									let downloadTracked = false;

									if (downloadTracked) {
										return;
									}

									this.removeAllListeners();
									clickEventTriggered = true;
									window.open(originalHref, target);
									downloadTracked = true;
									setTimeout(() => {
										downloadTracked = false;
										clickEventTriggered = false;
									}, 500);

									_this.hiddenSubmitForm(HiddenFormSubmitId);
								}
							}
						}
					} else {
						window.open(originalHref, target);
					}
				} else {
					console.log('lightbox: get partial-view failed');
					this.closeLightbox();
					this.doSubmitAction(false, '', '');
				}
			},
			complete: () => {
				this.hideIndicator();
			},
		});
	}

	SubmitWebContentDownloadPreferences(
		submissionType: any,
		submissionSource: any,
		selectedPreference: string,
		profile: any,
		campaignId: string
	) {
		$.ajax({
			type: 'GET',
			url:
				window.location.origin +
				'/partial-updates/sapcdc/updatepreferencesincdp?' +
				'userPreference=' +
				selectedPreference +
				'&emailId=' +
				encodeURIComponent(profile.email) +
				'&campaignId=' +
				campaignId +
				'&submissionType=' +
				submissionType +
				'&submissionSource=' +
				submissionSource +
				'&firstName=' +
				profile.firstName +
				'&lastName=' +
				profile.lastName +
				'&formUrl=' +
				encodeURIComponent(window.location.href),
			dataType: 'html',
			success: (response: any) => {
				console.log('Web content download preferences updated successfully.');
			},
			error: (xhr: any, status: any, error: any) => {
				console.error('Error updating web content download preferences:', status, error);
			},
		});
	}

	loadForm(originalHref: string, videoId: string = '', target: string = '') {
		let _this = this;

		let $formContainer = this.$ctx.find(`div[data-id="formContainer"]`);

		setTimeout(() => {
			let formId = $formContainer.data('form-id');
			let ppformId = $formContainer.data('pp-form-id');
			let screenSetId = $formContainer.data('screen-set-id');
			let contextLang = $formContainer.data('context-language');
			_this.hideIndicator();
			_this.displayFormBox();
			this.loadSapCdcForm(formId, screenSetId, contextLang, null, originalHref, videoId, target, ppformId);
		}, 3000);
	}

	loadSapCdcForm(
		formId: string,
		screenSetId: string,
		contextLang: string,
		errorMsg: JQuery,
		originalHref: string = '',
		videoId: string = '',
		target: string = '',
		ppFormId: string = ''
	) {
		let $this = this;
		let gigyaSapCdc = (window as any)['gigya'];
		console.log('Gigya Settings loadSapCdcForm----' + gigyaSapCdc);
		originalLinkHref = originalHref;
		originalvideoId = videoId;
		originalHrefTarget = target;

		let startScreenId =
			Cookies.get('cdcUserData') === undefined && Cookies.get('cdcProfileData') === undefined
				? formId
				: ppFormId !== undefined && ppFormId !== ''
					? ppFormId
					: formId;
		const divElement = document.getElementById('sapCdcForm_' + formId);
		divElement.id = 'sapCdcForm_' + startScreenId;

		if (typeof gigyaSapCdc != 'undefined') {
			var formContainerId = 'sapCdcForm_' + startScreenId;
			gigyaSapCdc.accounts.showScreenSet({
				screenSet: screenSetId,
				startScreen: startScreenId,
				containerID: formContainerId,
				lang: contextLang,
				onAfterScreenLoad: function(eventObj: any) {
					console.log('Screen Loaded:', eventObj.sourceContainerID);
					$this.sapCdcService = new SapCdcFormGlobal();
					$this.sapCdcService.updateFormFields(eventObj, errorMsg);
					$this.sapCdcService.setFormStartDataToGtm(eventObj.sourceContainerID);
				},
				onBeforeSubmit: function(event: any) {
					console.log('Before submit event:', event);
				},
				onAfterSubmit: function(event: any) {
					$this.sapCdcService = new SapCdcFormGlobal();

					console.log('After submit event:', event);
					if (event !== null && event.response !== null && event.response.UID !== null) {
						$this.sapCdcService.onSapCdcAfterSubmitForLightBox(
							event,
							classes.stateContentHide,
							originalLinkHref,
							originalvideoId,
							originalHrefTarget
						);
						$this.sapCdcService.submitDataToGtm('sapCdcForm_' + event.screen);
					}
				},
				onSubmitSuccess: function(event: any) {
					console.log('Submit success:', event);
				},
				onError: function(error: any) {
					console.error('Submit error:', error);
				},
			});
		}
	}

	hiddenSubmitForm(hiddenForm: any) {
		let formId = hiddenForm;
		let formName = formId;
		const trackdata: {
			event: string;
			form_id: string;
			form_name: string;
			form_destination: string;
			form_hidden_submit_text: string;
		} = {
			event: 'hidden_form_submit',
			form_id: formId,
			form_name: formName.toString(),
			form_destination: '',
			form_hidden_submit_text: '',
		};
		Track.gtmTrack(trackdata);
	}

	rebindEvents() {
		let $this = this;

		this.$ctx.find(`.${classes.buttonClose}`).on('click', function() {
			$this.closeLightbox();
		});
	}

	removeCloseEvents() {
		let $this = this;

		this.$ctx.find(`.${classes.buttonClose}`).off('click', function() {
			$this.closeLightbox();
		});
	}

	showLightbox() {
		$('html')
			.find(`.${classes.lightbox}`)
			.addClass(classes.stateLightboxVisible);
		$('html').addClass('no-scrolling--without-scrollbar');
	}

	closeLightbox() {
		this.$ctx.removeClass(classes.stateLightboxVisible);
		this.$ctx.find(`.${classes.lightboxDialog}`).empty();
		$('html').removeClass('no-scrolling--without-scrollbar');
	}

	displayConfirmationBox() {
		let $confirmContainer = this.$ctx.find(`div[data-id="confirmationContainer"]`);
		$confirmContainer.removeClass(classes.stateContentHide);
	}

	displayFormBox() {
		let $formContainer = this.$ctx.find(`div[data-id="formContainer"]`);
		$formContainer.removeClass(classes.stateContentHide);
	}

	hideFormBox() {
		let $formContainer = this.$ctx.find(`div[data-id="formContainer"]`);
		$formContainer.addClass(classes.stateContentHide);
	}

	hideIndicator() {
		let $dialog = this.$ctx.find(`.${classes.lightboxDialog}`);
		$dialog.removeClass(classes.stateContentHide);

		let $indicator = this.$ctx.find(`.${classes.lightboxLoading}`);
		$indicator.addClass(classes.stateContentHide);
	}

	showIndicator() {
		let $dialog = this.$ctx.find(`.${classes.lightboxDialog}`);
		$dialog.addClass(classes.stateContentHide);

		let $indicator = this.$ctx.find(`.${classes.lightboxLoading}`);
		$indicator.removeClass(classes.stateContentHide);
	}

	doSubmitAction(showConfirmationMsg: boolean, originalHref: string, videoId: string = '') {
		// confirmation message
		if (showConfirmationMsg) {
			this.hideFormBox();
			this.displayConfirmationBox();

			// go to original link
		} else {
			this.closeLightbox();
			if (videoId.length > 0) {
				//play
				$('[data-video-id="' + videoId + '"] .mi-big-play-cover').trigger('click');
				$('[data-video-id="' + videoId + '"] .js-a-video__locked').remove();
			} else {
				if (originalHref != undefined && originalHref.length > 0) {
					window.location.href = originalHref;
				}
			}
		}
		//unlock
		$('.a-video--locked').removeClass('a-video--locked');
		$('.m-download-item--locked').removeClass('m-download-item--locked');
		$('.m-download-table__item--locked').removeClass('m-download-table__item--locked');
		$('.m-hero-article-stage--locked').removeClass('m-hero-article-stage--locked');
		$('.m-scrollable-teaser-item--locked').removeClass('m-scrollable-teaser-item--locked');
		$('.m-talk--locked').removeClass('m-talk--locked');
		$('.m-teaser-large--locked').removeClass('m-teaser-large--locked');
		$('.o-teaser-content-area__item').each((i, e) => {
			const $teaser = $(e).children();
			const classList = $teaser.attr('class');
			const className = classList.split(' ');
			$teaser.removeClass(className[0] + '--locked');
		});
	}

	stop() {}
}
